module.exports = __webpack_public_path__ + "img/KinokoTable66.25631e36.jpg";